import React from "react";
import { Col, Container, Row } from "reactstrap";
import MainNavigation from "../components/MainNavigation";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantsAction } from "../store/actions/restaurantsAction";
import { useEffect } from "react";

const Info = () => {
  const dispatch = useDispatch();
  const { darkMode, color } = useSelector((state) => state.global);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);

  const dayOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const sortDays = (days) => {
    if (!Array.isArray(days)) return [];
    return [...days].sort(
      (a, b) => dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day)
    );
  };

  const formatTime = (time) => {
    if (!time) return "";
    let [hours, minutes] = time.split(":")?.map(Number);
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  useEffect(() => {
    const ID = localStorage.getItem("restaurantId");
    if (ID) {
      dispatch(getRestaurantsAction(ID));
    }
  }, []);

  return (
    <div className={darkMode ? "info__main__dark" : "info__main"}>
      <Container className="info">
        <MainNavigation title={"Info"} />
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <Col>
            <h4 style={{ color }} className="info__restaurant_name">
              {restaurantsDetail?.name}
            </h4>
          </Col>
          <Col>
            <h6 className="info__sub_heading">Stay Safe</h6>
          </Col>
        </Row>

        <hr className="info__divider" />
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <Col>
            <h5 className="info__heading">Address</h5>
          </Col>
          <Col>
            <h6 className="info__sub_heading">{restaurantsDetail?.location}</h6>
          </Col>
        </Row>

        <hr className="info__divider" />
        <h5 className="info__heading">Opening Hours for Pickup</h5>
        {sortDays(restaurantsDetail?.pickupDays)?.map((item, index) => (
          <Row
            key={index}
            className="d-flex justify-content-between align-items-center mx-2"
          >
            <h5 className="info__sub_heading">{item?.day}</h5>
            <h5 className="info__sub_heading">
              {formatTime(item?.startTime)} - {formatTime(item?.endTime)}
            </h5>
          </Row>
        ))}

        <hr className="info__divider" />
        <h5 className="info__heading">Opening Hours for Delivery</h5>
        {sortDays(restaurantsDetail?.deliveryDays)?.map((item, ind) => (
          <Row
            key={ind}
            className="d-flex justify-content-between align-items-center mx-2"
          >
            <h5 className="info__sub_heading">{item?.day}</h5>
            <h5 className="info__sub_heading">
              {formatTime(item?.startTime)} - {formatTime(item?.endTime)}
            </h5>
          </Row>
        ))}

        <hr className="info__divider" />
        <h5 className="info__heading">Store Timings</h5>
        {sortDays(restaurantsDetail?.storeTiming)?.map((item, id) => (
          <Row
            key={id}
            className="d-flex justify-content-between align-items-center mx-2"
          >
            <h5 className="info__sub_heading">{item?.day}</h5>
            <h5 className="info__sub_heading">
              {formatTime(item?.startTime)} - {formatTime(item?.endTime)}
            </h5>
          </Row>
        ))}
      </Container>
    </div>
  );
};

export default Info;
